import React from 'react';
import { Check, AlertCircle } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 bg-stone-50 relative overflow-hidden" data-id="element-240">
      {/* Background image with transparency */}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-end" data-id="element-241">
        <img src="https://cdn.magicpatterns.com/uploads/sE7egBCBpu4Sf45UqbA6cJ/ChatGPT_Image_22_ene_2026,_19_56_10_(1)_(1).png" alt="" className="h-full max-h-[90%] w-auto object-contain opacity-10 mr-0 lg:mr-8" data-id="element-242" />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <div className="max-w-4xl mx-auto" data-id="element-244">
          <div className="text-center mb-12" data-id="element-245">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-246">
              ¿Te esforzás por cuidarte… y aun así terminás inflamada?
            </h2>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-247">
              <p data-id="element-248">Hacés lo que podés. Comés bien. Tomás agua. Evitás lo peor.</p>
              <p data-id="element-249">
                Y sin embargo… te levantás hinchada. Te acostás pesada. Y en
                algún momento del día mirás tu panza y pensás:{' '}
                <span className="italic font-semibold text-gray-900" data-id="element-250">
                  ¿qué hice mal ahora?
                </span>
              </p>
              <p data-id="element-251">
                Eso agota. No solo tu cuerpo. Te agota mentalmente. Y lo peor no
                es la hinchazón. Lo peor es no entender por qué.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden mb-12" data-id="element-252">
            <div className="bg-stone-100 px-6 py-4 border-b border-stone-200 flex items-center gap-2" data-id="element-253">
              <AlertCircle className="w-5 h-5 text-stone-500" data-id="element-254" />
              <h3 className="font-bold text-stone-800" data-id="element-255">¿Te suena familiar?</h3>
            </div>

            <div className="divide-y divide-stone-100" data-id="element-256">
              {['Te levantás con panza hinchada aunque cenaste liviano', 'Tenés antojos de dulce todo el día que no podés ignorar', 'Te sentís pesada y sin energía después de comer', 'Probás dietas y siempre volvés al punto cero', 'Vivís cansada aunque estés haciendo todo bien'].map((item, idx) => <div key={idx} className="flex items-start p-5 hover:bg-stone-50 transition-colors" data-id="element-257">
                  <div className="flex-shrink-0 mt-1" data-id="element-258">
                    <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center" data-id="element-259">
                      <Check className="w-4 h-4 text-red-600" data-id="element-260" />
                    </div>
                  </div>
                  <p className="ml-4 text-gray-700 font-medium" data-id="element-261">{item}</p>
                </div>)}
            </div>
          </div>

          <div className="text-center" data-id="element-262">
            <p className="text-xl md:text-2xl font-medium inline-block px-8 py-4 rounded-xl border border-emerald-100 text-gray-900 bg-[#f8f8be]" data-id="element-263">
              Si asentiste aunque sea una vez… tu cuerpo no necesita más fuerza
              de voluntad. <span className="font-bold" data-id="element-264">Necesita orden.</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}